module.exports = new __parcel__URL__("bg.72fa4e69.jpg").toString();